import React, { useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleResetPassword = (e) => {
    e.preventDefault();
    axios.post(`https://api.finaloffers.fyi/auth/reset-password/${token}`, { password })
      .then(response => {
        setMessage(response.data.message);
        if (response.data.message === 'Password reset successful') {
          navigate('/login');
        }
      })
      .catch(error => {
        setMessage(error.response.data.message);
      });
  };

  return (
    <form onSubmit={handleResetPassword}>
      <input
        type="password"
        placeholder="New Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      <button type="submit">Set New Password</button>
      {message && <p>{message}</p>}
    </form>
  );
}

export default ResetPassword;
